import * as type from 'constants/ActionTypes';

export const fetchExtensions = params => ({
  type: type.FETCH_EXTENSIONS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: 'refdata/extensions',
      params: {
        ...params,
      },
    },
  },
});

export const fetchExtensionsFailure = (error, meta = {}) => ({
  type: type.FETCH_EXTENSIONS_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const fetchExtensionsSuccess = payload => ({
  type: type.FETCH_EXTENSIONS_SUCCESS,
  payload,
});
